import axios from 'axios';
import { ref, watch } from 'vue';

// 创建 axios 实例
const domain = window.location.hostname;
const fullDomain = window.location.origin;
console.log(domain)
console.log(fullDomain)
const api = axios.create({
  //baseURL: 'http://192.168.0.163/index.php/',
  baseURL: 'http://61.136.101.125:8020/index.php/',
  //baseURL: 'http://gj.librarydata.cn/index.php/',
  //baseURL: 'http://localhost/index.php/',
  //baseURL: fullDomain + '/index.php/',
  timeout: 300000, // 请求超时
  headers: {
    'Content-Type': 'multipart/form-data',
  },
});

// 请求拦截器
api.interceptors.request.use(
  (config) => {
    // 在请求发送前进行处理
    // 获取缓存中的用户信息
    const userInfo_linshi = localStorage.getItem('userInfo');
    if (userInfo_linshi) {
      config.headers['Ba-user-Token'] = JSON.parse(userInfo_linshi).token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器
api.interceptors.response.use(
  (response) => {
    if (response.data.code == 303 || response.data.code == 409) {
      // 根据业务需求做错误处理
      return response.data;
    }
    if (response.data.code !== 1) {
      // 根据业务需求做错误处理
      return Promise.reject(new Error(response.data.msg || 'Error'));
    }
    return response.data;
  },
  (error) => {
    console.error('请求失败:', error);
    return Promise.reject(error);
  }
);

// 封装常用的请求方法
export const get = (url, params) => {
  return api.get(url, { params });
};

export const post = (url, data) => {
  return api.post(url, data);
};

export const put = (url, data) => {
  return api.put(url, data);
};

export const del = (url) => {
  return api.delete(url);
};
